import defaultLocaleValue from '@visma/react-app-locale-utils/lib/defaultLocale.js';
import useLocale from '@visma/react-app-locale-utils/lib/useLocale.js';
import React from 'react';
import { IntlProvider as ReactIntlProvider } from 'react-intl';
import useMessages from './useMessages.js';
export default function IntlProvider({ locale, defaultLocale = defaultLocaleValue, messages, ...otherProps }) {
    const [localeSetting] = useLocale();
    locale = locale !== null && locale !== void 0 ? locale : localeSetting;
    return (React.createElement(ReactIntlProvider, { messages: {
            ...useMessages({ locale, defaultLocale }),
            ...messages,
        }, locale: locale, defaultLocale: defaultLocale, ...otherProps }));
}
//# sourceMappingURL=IntlProvider.js.map